import React from "react";
import {connect} from 'react-redux'
import {compose} from 'recompose';
import {withRouter} from 'react-router';

const Authorized = ({hasAccess, children}) => hasAccess ? <div>{children}</div> : null

const mapStateToProps = (state, {userrole, redirect, history: {push}}) => {
    const hasAccess = state.auth.currentAuth ? (state.auth.currentAuth.authorities.indexOf(userrole) > -1) : false;
    !hasAccess && redirect && push(redirect);
    return {
        hasAccess
    };
};

export default compose(
    withRouter,
    connect(mapStateToProps),
)(Authorized);


// WEBPACK FOOTER //
// ./src/components/auth/Authorized.js